import script from "./search-template.vue?vue&type=script&setup=true&lang=ts"
export * from "./search-template.vue?vue&type=script&setup=true&lang=ts"

import "./search-template.vue?vue&type=style&index=0&id=2b218a0c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b218a0c"]])

export default __exports__